<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <template>
            <div class="container-fluid xyz">
                <!--page content-->
                <div class="admin-page-content">
                    <div class="page-title-container">
                        <div class="page-name">{{pageTitle}}</div>
                        <button type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Back</span></button>
                    </div>
                    <!--Forms-->
                    <div class="forms-container default-bx-shadow responsive-forms-container">
                        <div class="row no-margin">
                            <!-- Form -->
                            <!-- <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Form :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <v-select v-model="formId" name="formId"
                                        label="text"
                                        @input="changeFormMaster"
                                        :options="formIdArr" :clearable=false placeholder="Select Form">
                                    </v-select>
                                    <div class="help is-danger">{{formIdError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div> -->
                            <!-- Location -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Location :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <!-- <v-select v-model="location" name="location"
                                        label="name" placeholder="Select Location"
                                        @input="location_error = ''"
                                        :options="location_arr" :clearable=false>
                                    </v-select> -->
                                    <v-select v-model="location" name="location"
                                        label="label"
                                        placeholder="Select Location"
                                        :options="location_arr" :clearable=false
                                        @input="location_error=''">
                                    </v-select>
                                    <div class="help is-danger">{{location_error}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <template>
                                <!-- Department -->
                                <div class="col-6 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label">Department :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <v-select v-model="department" name="department"
                                            label="text"
                                            :options="departmentArr" :clearable=false placeholder="Select Department"
                                            @input="departmentError=''">
                                        </v-select>
                                        <div class="help is-danger">{{departmentError}}</div>
                                        <div class="requiredstar">*</div>
                                    </div>
                                </div>
                            </template>
                            <!-- To Email -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">To Email :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <vue-tags-input
                                        v-model="toEmail"
                                        :tags="toEmailTagsArr"
                                        :validation="validation"
                                        @tags-changed="handleToEmlTagsChanged"
                                        @before-adding-tag="checkToEmailTag"
                                        placeholder=""
                                        @input="toEmailError=''"
                                    />
                                    <div class="help is-danger">{{toEmailError}}</div>
                                    <div class="requiredstar">*</div>
                                </div>
                            </div>
                            <!-- CC Email -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">CC Email :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <!-- <input type="text" maxlength="190" class="form-control" v-model="ccEmail" id="ccEmail" placeholder="Enter CC Email" name="ccEmail"> -->
                                    <!--<input @input="emailError = ''" id="email" v-model="email" class="form-control" type="text"/>-->
                                    <vue-tags-input
                                        v-model="ccEmail"
                                        :tags="ccEmailTagsArr"
                                        :validation="validation"
                                        @tags-changed="newTags => ccEmailTagsArr = newTags"
                                        @before-adding-tag="checkCCEmailTag"
                                        placeholder=""
                                    />
                                    <div class="help is-danger">{{ccEmailError}}</div>
                                    <!-- <div class="requiredstar">*</div> -->
                                </div>
                            </div>
                            <div class="clearfix"></div>
                            <div class="mr-17 pb-12 float-l">
                                <button type="button" id="cancelAttachment" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="buttonBack"><span>Cancel</span></button>
                                <button v-if="edit_id == 0" type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addEmailManagerData('save_and_continue')"><span id="saveAndContinueAttachment">Save And Continue</span></button>
                                <button type="submit" class="ml-2 btn btn-primary pull-right themebutton" v-on:click.prevent="addEmailManagerData('save')"><span id="createAttachment">Save</span></button>
                            </div>

                        </div>
                    </div>
                    <!-- Forms -->
                </div>
                <!--page content-->
            </div>
        </template>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import vSelect from 'vue-select';
    import {HTTP, HTTPVELOCITY} from '../../http-common';
    import {commonMixins} from '../../mixins/commonMixins';
    import EventBus from "../event-bus";
    import VueTagsInput from '@johmun/vue-tags-input';
    import {getHeader} from "../../config";

    var app;
    Vue.component('v-select', vSelect);
    Vue.component("app-footer", Footer);
    export default {
        name: 'AddUpdateEmailManager',
        mixins: [commonMixins],
        components: {
            VueTagsInput,
        },
        data() {
            return {
                //user_role: 0,
                pageTitle: 'Add Email Manager',
                edit_id: 0,
                toEmail:"",
                ccEmail: "",
                toEmailTagsArr:[],
                ccEmailTagsArr: [],
                validation: [{
                    classes: 'valid-email',
                    rule: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                }],
                isValidToEmailTag :true,
                isValidCCEmailTag : true,
                toEmailError:"",
                ccEmailError: "",
                departmentArr: [],
                department: "",
                departmentError: "",
                location: [],
                location_arr: [],
                location_error: "",
                loginUserRoleId: 1,
                bodyShopLocationArr: [],
                serviceLocationArr: [],
                locationArr: [],
                permissionsArray: ['access_form_email_manager'],
                laborReviewLocationArr: [],
                old_location_id: 0,
                old_dept_id: 0,
                location_api_in_process:0,
                department_api_in_process:0,
                isFormType: 'gl_export',
                isToEmailTagEmpty: true
            }
        },
        watch: {
        },
        beforeMount: function () {
            app = this;
        },
        created: function () {
        },
        mounted: function () {
          //  app.loadFormMasterData();
            app.setActiveMenu("email-manager");
            EventBus.$emit("menu-selection-changed", "email-manager");
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
              //  app.loginUserRoleId = userJson['role'].system_id;
            }
            this.$nextTick(function () {
                if (typeof(app.$route.params.id)  != 'undefined' && app.$route.params.id != 0 && app.$route.params.id != '') {
                    app.edit_id = app.$route.params.id;
                    app.pageTitle = 'Edit Email Manager';
                    app.getEmailManagerDataById();
                    $("#addAndContinueLocationBtn").hide();
                    $("#createAttachment").html("Update");
                }
            });
            // app.loadBodyShopLocation();
            app.location_api_in_process=1;
            app.department_api_in_process=1;
            app.loadLocation();
            app.loadDepartmentData();
        },
        methods: {
            buttonBack() {
                app.$router.push('/email-manager');
            },
            
            checkToEmailTag: function(obj) {
                app.toEmailError = "";
                app.isToEmailTagEmpty = false;
                app.isValidToEmailTag = true;
                var tagEmail = JSON.stringify(obj.tag.text).split('"');
                if(!tagEmail[1]) {
                    app.isToEmailTagEmpty = true;
                } else if(tagEmail[1] && !app.validEmail(tagEmail[1])) {
                    app.isValidToEmailTag = false;
                } else obj.addTag();
            },
            handleToEmlTagsChanged: function(newTags) {
                app.toEmailTagsArr = newTags; // Update the tags array

                app.toEmailError = "";
                app.isToEmailTagEmpty = false;
                app.isValidToEmailTag = true;

                // Check if there are empty or invalid tags after tag change
                if (app.toEmailTagsArr.length === 0) {
                    app.isToEmailTagEmpty = true;
                } else {
                    // Check for invalid email tags
                    let invalidTagFound = app.toEmailTagsArr.some(tag => !app.validEmail(tag.text));
                    if (invalidTagFound) {
                        app.isValidToEmailTag = false; // It's not empty but has invalid email(s)
                    }
                }
            },
            checkCCEmailTag: function(obj) {
                app.ccEmailError = "";
                app.isValidCCEmailTag = true;
                var tagEmail = JSON.stringify(obj.tag.text).split('"');
                if(!app.validEmail(tagEmail[1])) {
                    app.isValidCCEmailTag = false;
                    app.ccEmailError = "Please enter valid Email";
                } else obj.addTag();
            },
            // changedValueLocation: function(location) {
            //     app.location_error = "";
            //     app.departmentArr = [];
            //     app.department= [];
            //     if(location != '' && location != null) {
            //         if (location != 'undefined' && location.id) {
            //             app.showLoader();
            //             app.loadDepartmentData(location);
            //         }
            //     }
            // },
            getEmailManagerDataById: function() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        id: app.edit_id,
                    }
                };
                app.showLoader();
                HTTP.get("/email/manager/getbyid", config)
                        .then(function (response) {
                            setTimeout(function() {
                                app.location=({"name": response.data.content.location, "label": response.data.content.location+"("+response.data.content.location_id+")", "id": response.data.content.location_id, "excede_location_id": response.data.content.location_id});
                                var selectedLocation = { id: response.data.content.location_id };
                                if(response.data.content.department && response.data.content.department_id) {
                                    app.department=({"text": response.data.content.department+"("+response.data.content.department_id+")", "label":response.data.content.department, "value": response.data.content.department_id});
                                }
                                app.loadDepartmentData(selectedLocation);
                                app.hideLoader();
                            }, 50);
                            if(response.data.content.location && response.data.content.location_id) {
                                app.old_location_id=response.data.content.location_id;
                            }
                            if(response.data.content.department && response.data.content.department_id) {
                                app.old_dept_id=response.data.content.department_id;
                            }
                            if(response.data.content.cc_email && response.data.content.cc_email != 'NULL') {
                                var ccEmailArr = response.data.content.cc_email.split(",");
                                for(var index = 0; index < ccEmailArr.length; index++) {
                                    app.ccEmailTagsArr.push({"text": ccEmailArr[index], "tiClasses": ["ti-valid"]});
                                }
                            }
                            if(response.data.content.to_email && response.data.content.to_email != 'NULL') {
                                var toEmailArr = response.data.content.to_email.split(",");
                                for(var index = 0; index < toEmailArr.length; index++) {
                                    app.toEmailTagsArr.push({"text": toEmailArr[index], "tiClasses": ["ti-valid"]});
                                }
                            }
                        })
                        .catch(function (err) {
                            console.log(err);
                            app.hideLoader();
                            app.catchHandler(err, function () {});
                        });
            },
            loadDepartmentData: function(location) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        form_type: app.isFormType,
                    }
                };
                HTTP.get('/department/manager/getall', config)
                    .then(function (response) {
                        app.department_api_in_process=0;
                        if(response && response.data) {
                            app.departmentArr = response.data.content;
                            app.departmentArr = app.departmentArr.sort((a, b) => { return a.name.localeCompare(b.name);});
                            app.departmentArr.forEach(element => {
                                // app.departmentArr.push({'text' : element.name+"("+element.excede_department_id+")", 'label':element.name, 'value' : element.excede_department_id});
                                element.text = element.name+"("+element.excede_department_id+")";
                                element.value=element.excede_department_id;
                                element.label=element.name;
                            });
                            if(app.location_api_in_process==0) {
                                app.hideLoader();
                            }
                        }
                    })
                    .catch(function (err) {
                        app.catchHandler(err, function () {});
                        app.hideLoader();
                    });
            },
            
            loadLocation: function() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        form_type: app.isFormType,
                    }
                };
                app.showLoader();
                HTTP.get("/location/manager/getall", config)
                        .then(function (response) {
                            app.location_api_in_process=0;
                            app.location_arr = response.data.content;
                            app.location_arr = app.location_arr.sort((a, b) => { return a.name.localeCompare(b.name);});
                            app.location_arr.forEach(element => {
                                element.label=element.name+"("+element.excede_location_id+")";
                            });
                            if(app.department_api_in_process==0) {
                                app.hideLoader();
                            }
                        })
                        .catch(function (err) {
                            app.hideLoader();
                            app.catchHandler(err, function () {});
                        });
            },
            checkForm: function () {
                var checked = true;
                app.location_error = "";
                app.departmentError = "";
                app.toEmailError = "";
                app.ccEmailError = "";
                app.isValidCCEmailTag = true;
                if (app.location.length == 0) {
                    app.location_error = "select Location";
                    if (checked) {
                        checked = false;
                    }
                }
                if (app.department.length == 0) {
                    app.departmentError = "select Department";
                    if (checked) {
                        checked = false;
                    }
                }
                if (app.isToEmailTagEmpty) {
                    app.toEmailError = "Please enter email";
                    if (checked) {
                        checked = false;
                    }
                } else if(!app.isValidToEmailTag){
                    app.toEmailError = "Please enter valid Email"; // Display error if any email is invalid
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            addEmailManagerData(flag) {
                setTimeout(() => {
                    if (app.checkForm() && app.isValidCCEmailTag && app.isValidToEmailTag) {
                        var toEmailData = "";
                        if(app.toEmailTagsArr && app.toEmailTagsArr.length > 0) {
                            for(var index = 0;index<app.toEmailTagsArr.length;index++) {
                                if(!toEmailData.includes(app.toEmailTagsArr[index].text)) {
                                    toEmailData += (app.toEmailTagsArr[index].text) + ',';
                                }
                            }
                            toEmailData = toEmailData.replace(/,\s*$/, "");
                        }
                        var ccEmailData = "";
                        if(app.ccEmailTagsArr && app.ccEmailTagsArr.length > 0) {
                            for(var index = 0;index<app.ccEmailTagsArr.length;index++) {
                                if(!ccEmailData.includes(app.ccEmailTagsArr[index].text)) {
                                    ccEmailData += (app.ccEmailTagsArr[index].text) + ',';
                                }
                            }
                            ccEmailData = ccEmailData.replace(/,\s*$/, "");
                        }
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                        };
                        let deptName="", deptId=0;
                        if(app.department) {
                            deptName=app.department.label;
                            deptId=app.department.value;
                        }
                        var user = JSON.parse(localStorage.getItem('user_obj'));
                        var login_userid=0;
                        if(user) {
                            login_userid=user.emp_id;
                        }
                        var fields = {
                            id: app.edit_id,
                            location: app.location.excede_location_id,
                            location_name: app.location.name,
                            department:deptId,
                            department_name:deptName,
                            to_email: toEmailData,
                            cc_email: ccEmailData,
                            old_location_id: app.old_location_id,
                            old_dept_id: app.old_dept_id,
                            userid: login_userid,
                            form_type: app.isFormType
                        };
                        app.showLoader();
                        HTTP.post("/email/manager/add/update", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    app.showSAlert(response.data.message, 'success');
                                    if (flag == 'save') {
                                        app.buttonBack();
                                    } else {                                        
                                        app.clearSaveAndContinue();
                                    }
                                }
                                app.hideLoader();
                            })
                            .catch(function (err) {
                                app.hideLoader();
                                app.catchHandler(err, function () {});
                            });
                    }
                }, 200);
            },
            clearSaveAndContinue: function() {
                app.edit_id = 0;
                app.department = '';
                app.location = '';
                app.toEmail = '';
                app.ccEmail = '';
                app.toEmailTagsArr = [];
                app.ccEmailTagsArr = [];
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            numberFormateValidation : function (inputtxt) {
                var valid = !/^\s*$/.test(inputtxt) && !isNaN(inputtxt);
                return valid;
            },
        }
    };
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/EmailManager/AddUpdateEmailManager.vue